
interface Props {
    isLoading: boolean
    message?: string
    children: any
}

export default function RelativeLoadingFrame(props: Props) {
    if (props.isLoading)
        return (
            <div className="relative w-full h-full flex flex-col items-center justify-center gap-4">
                <img src="/loader-slow.gif" className="h-16 w-16" alt="" />
                {props.message && <p className="text-lg text-gray-400 mt-2">{props.message}</p>}
            </div>
        )

    return (
        <>
            {props.children}
        </>
    )
}
